import * as React from 'react';
import { PromoteInstallmentsLabel } from '@grandvisionhq/content';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PromoteInstallmentsModalSlot } from './PromoteInstallmentsModalSlot/PromoteInstallmentsModalSlot.js';

// when enabledProduct is undefined this component will render for every product type
// when enabledProduct is set e.g. ['sunglasses'] it will render ONLY for this product type
const getExcludedProductType = (enabledProductTypes, productType)=>{
    if (!enabledProductTypes || !productType) {
        return false;
    }
    return !enabledProductTypes.some((product)=>product.toLowerCase() === productType.toLowerCase()
    );
};
const PromoteInstallments = ({ siteLogos , numberOfInstallments , minimumPrice , productType , enabledProductTypes , textAlign  })=>{
    const { currency , locale  } = useIntl();
    const { displayPrice  } = useProductData();
    const priceAmount = displayPrice.discountedPrice || displayPrice.originalPrice;
    const excludedProductType = getExcludedProductType(enabledProductTypes, productType);
    const isCentAmount = false;
    const installmentPrice = formatPrice({
        locale,
        value: priceAmount / numberOfInstallments,
        currency,
        isCentAmount
    });
    // conditions to render component
    if (priceAmount < minimumPrice || excludedProductType) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PromoteInstallmentsLabel, {
        installmentPrice: installmentPrice,
        numberOfInstallments: numberOfInstallments,
        textAlign: textAlign,
        modalBodySlot: /*#__PURE__*/ React.createElement(PromoteInstallmentsModalSlot, {
            siteLogos: siteLogos,
            price: priceAmount,
            isCentAmount: isCentAmount,
            numberOfInstallments: numberOfInstallments
        })
    });
};

export { PromoteInstallments };
//# sourceMappingURL=PromoteInstallments.js.map
